import { Component, Output, EventEmitter, HostListener, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router, UrlSegment } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";


import { EventService } from "src/app/services/event.service";
import { PopupService } from "src/app/services/popup.service";
import { ConnectComponent } from "src/app/modals/connect/connect.component";
import { WalletConnectService } from "src/app/services/wallet-connect.service";
import { getParamWithoutCookie } from "src/app/shared/constants/app-enums";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})


export class SidebarComponent implements AfterViewInit {

  @Output() dashboardToggled = new EventEmitter<boolean>();
  isExpanded: boolean = true;
  currentTab: string = "";
  currentLanguage: any;
  isActive: boolean = false;
  showBW: boolean = false;
  bwUrl: string = "";
  tokenSubMenuOpened = false;
  isMobile = (window?.matchMedia && window?.matchMedia("(max-device-width: 1024px)").matches) || screen.width <= 1024;
  isProd = environment.production;

  list1 = [
    {
      routeName: "casino",
      img: "/assets/images/sidebar/casino.svg",
      name: "casino",
      linkedUrl: "https://wsmcasino.com/",
    },
    {
      img: "/assets/images/sidebar/slots.svg",
      name: "slots",
      linkedUrl: "https://www.wsmcasino.com/slots",
      routeName: "Slots",
    },
    {
      img: "/assets/images/sidebar/live-casino.svg",
      name: "live_casino",
      linkedUrl: "https://www.wsmcasino.com/live-casino",
      routeName: "Live Casino",
    },
    {
      img: "/assets/images/sidebar/game-shows.svg",
      name: "game_shows",
      linkedUrl: "https://www.wsmcasino.com/game-shows",
      routeName: "Game shows",
    },
    {
      img: "/assets/images/sidebar/crash-games.svg",
      name: "crash_game",
      linkedUrl: "https://www.wsmcasino.com/crash-games",
      routeName: "Crash game",
    },
  ];

  list2 = [
    {
      img: "/assets/images/sidebar/sport.svg",
      name: "sports",
      linkedUrl: "https://www.wsmcasino.com/sports",
      routeName: "Sports",
    },
    {
      img: "/assets/images/sidebar/football.svg",
      name: "footbaal",
      linkedUrl: "https://www.wsmcasino.com/sports?bt-path=%2Fsoccer-1",
      routeName: "Footbaal",
    },
    {
      img: "/assets/images/sidebar/tennis.svg",
      name: "tennis",
      linkedUrl: "https://www.wsmcasino.com/sports?bt-path=%2Ftennis-5",
      routeName: "Tennis",
    },
    {
      img: "/assets/images/sidebar/in-play.svg",
      name: "in_play",
      linkedUrl: "https://www.wsmcasino.com/sports?bt-path=%2Flive",
      routeName: "In play",
    },
    {
      img: "/assets/images/sidebar/my-belt.svg",
      name: "my_belt",
      linkedUrl: "https://www.wsmcasino.com/sports?bt-path=%2Fbets",
      routeName: "My belt",
    },
    {
      img: "/assets/images/sidebar/favorite.svg",
      name: "favorite",
      linkedUrl: "https://www.wsmcasino.com/sports?bt-path=%2Ffavorites",
      routeName: "Favorite",
    },
  ];

  list3 = [
    {
      img: "/assets/images/sidebar/promotions.svg",
      name: "promotions",
      linkedUrl: "https://www.wsmcasino.com/en/promotions",
      routeName: "Promotions",
    },
    {
      img: "/assets/images/sidebar/buy-crypto.svg",
      name: "buy_crypto",
      linkedUrl: "https://www.wsmcasino.com/buy-crypto",
      routeName: "Buy Crypto",
    },
    {
      img: "/assets/images/sidebar/help.svg",
      name: "help",
      linkedUrl: "https://www.wsmcasino.com/faq",
      routeName: "Help",
    },
  ];
  modalRef?: BsModalRef;

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.isMobile =
      (window?.matchMedia &&
        window?.matchMedia("(max-device-width: 1024px)").matches) ||
      screen.width <= 1024;
  }

  // instant: any;
  constructor(
    private popupService: PopupService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private eventService: EventService,
    private walletConnectService: WalletConnectService,
    private modalService: BsModalService,
  ) {
    this.currentLanguage = this.eventService.currentLanguage;
    this.eventService.getLang().subscribe((val: any) => {
      this.currentLanguage = val || "en";
      console.log("currentLanguage =", this.currentLanguage);
    });

    //Active route
    this.activatedRoute.url.subscribe((url: UrlSegment[]) => {
      this.router.url.split("/")[2]
        ? (this.currentTab = this.router.url.split("/")[2])
        : (this.currentTab = "dashboard");
    });
    this.eventService.sidebarState.subscribe(event => {
      this.activeSidebar();
    })
  }

  ngAfterViewInit(): void {
    this.bwUrl = getParamWithoutCookie('bwUrl');
    if (this.bwUrl && this.bwUrl != '') {
      this.bwUrl = `?bwUrl=${this.bwUrl}`;
      this.showBW = true;
      console.log('this.bwUrl=', this.bwUrl)
    }
  }

  get walletAddress(): any {
    return this.walletConnectService.walletAddress;
  }

  activeSidebar() {
    this.isActive = !this.isActive;
  }


  toggleDashboard() {
    this.isExpanded = !this.isExpanded;
    this.dashboardToggled.emit(this.isExpanded);
  }
  comingSoon() {
    console.log("add");
    this.popupService.messagePopup(
      "info",
      this.translate.instant("coming_soon")
    );
  }

  onTabSelect(tab: string): void {
    this.currentTab = tab;
    this.isActive = false;
    this.router.navigateByUrl('/'+ this.currentLanguage + '/' + tab);
  }

  connectModal(): void {
    if (!this.walletAddress) {
        this.modalRef = this.modalService.show(ConnectComponent, {
          class: 'modal-min modal-dialog-centered',
          backdrop: 'static',
        });
        this.activeSidebar();
    }
  }

  disconnect() {
    this.walletConnectService.disConnectWallet();
    this.activeSidebar();
  }

  navigateToFragment(fragment: string) {
    this.router.navigateByUrl(`/${this.currentLanguage}/token#`+ fragment);
  }

  connectBestWallet() {
    window.scroll({ top: 10 });
    this.walletConnectService.connectWallet("bw");
  }
}
